<!--
 - report-viewer.component.html
 -
 - @version
 - 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 - 4.22.0 OAUI-390 Billing Report: build Angular UI
 -
 - @author Luis Hernandez <lhernandez@intersog.com>
 -
 - @copyright (c) 2021 Build Centrix
-->
<bc-atoms-loader
  title="Loading"
  [active]="!report"
  [fullscreen]="false"
></bc-atoms-loader>

<div [innerHTML]="report"></div>
